import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from "classnames";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";

// custom
import styles from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";


class CustomSelect extends Component {

    render() {
        const {
            classes,
            color,
            formControlProps,
            labelText,
            selectLabelText,
            id,
            inputProps,
            error,
            success,
            helpText,
            input,
            meta,
            selectOptions,
            multiple
        } = this.props;

        const isError = error || (meta && meta.touched && meta.error ? true : false);
        const errorMsg = helpText || (meta && meta.touched && meta.error);

        const labelClasses = classNames({
            [classes.labelRootError]: isError,
            [classes.labelRootSuccess]: success && !isError
        });

        const selectFormControlClasses = classNames(
            classes.selectFormControl, 
            "customSelectFormControl-fix", {
                [classes.underlineError]: isError,
                [classes.underlineSuccess]: success && !isError,
                [classes[color+"Underline"]] : !success && !isError
            }
        )
        var helpTextClasses = classNames({
            [classes.labelRootError]: isError,
            [classes.labelRootSuccess]: success && !isError
        });

        return (
            <FormControl
                {...formControlProps}
                className={selectFormControlClasses}
            >
                {labelText !== undefined ? (
                    <InputLabel
                        htmlFor={id}
                        className={classes.selectLabel + " " + labelClasses}
                    >
                        {labelText}
                    </InputLabel>
                ) : null}

                {/* Selectbox */}
                <Select
                    multiple={multiple}
                    MenuProps={{
                        className: classes.selectMenu
                    }}
                    classes={{
                        select: classes.select
                    }}
                    style={{ "marginTop": "0px" }}
                    {...inputProps}
                    {...input}
                >
                    {/* Selectbox 타이틀 */}
                    { selectLabelText && (
                        <MenuItem
                            disabled
                            classes={{
                                root: classes.selectMenuItem
                            }}
                        >
                            {selectLabelText}
                        </MenuItem>
                    )}
                    {/* Selectbox Option 출력 */}
                    { selectOptions && selectOptions.map( option => (
                        <MenuItem
                            key={option.value}
                            value={option.value}
                            classes={{
                                root: classes.selectMenuItem,
                                selected: classNames(classes.selectMenuItemSelected, classes[color + "BackgroundColor"])
                            }}
                        >
                            { option.text }
                        </MenuItem>
                    )) }
                </Select>
                { errorMsg && 
                    <FormHelperText id={id + "-text"} className={helpTextClasses}>
                        {errorMsg}
                    </FormHelperText>
                }
            </FormControl>
        );
    }
}

CustomSelect.defaultProps = {
    color: "primary"
};

CustomSelect.propTypes = {
    classes: PropTypes.object.isRequired,
    color: PropTypes.oneOf([
        "primary",
        "danger",
        "darkblue"
    ]),
    labelText: PropTypes.node,
    meta: PropTypes.object,
    multiple: PropTypes.bool,
    id: PropTypes.string,
    input: PropTypes.object,
    inputProps: PropTypes.object,
    formControlProps: PropTypes.object,
    error: PropTypes.bool,
    selectLabelText: PropTypes.node,
    selectOptions: PropTypes.array,
    success: PropTypes.bool,
    helpText: PropTypes.node
};

export default withStyles(styles)(CustomSelect);